"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styles_1 = require("./styles");
var TreeSelectorItem = /** @class */ (function (_super) {
    __extends(TreeSelectorItem, _super);
    function TreeSelectorItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFocus = function () {
            var _a = _this.props, item = _a.item, focused = _a.focused, onFocus = _a.onFocus;
            onFocus(item, !focused);
        };
        _this.handleChange = function () {
            var _a = _this.props, item = _a.item, selected = _a.selected, onSelect = _a.onSelect;
            onSelect(item, !selected);
        };
        return _this;
    }
    TreeSelectorItem.prototype.render = function () {
        var _a = this.props, label = _a.label, focused = _a.focused, checked = _a.selected, partiallySelected = _a.partiallySelected, onFocus = _a.onFocus, item = _a.item, className = _a.className;
        var isFocusable = !!onFocus && item.children && Object.values(item.children).length > 0;
        return (react_1.default.createElement(styles_1.Wrapper, { className: (isFocusable && focused ? 'focused' : '') + " " + className },
            react_1.default.createElement(styles_1.StyledCheckbox, { checked: partiallySelected ? false : checked, indeterminate: partiallySelected, onChange: this.handleChange }),
            react_1.default.createElement(styles_1.Label, { className: isFocusable ? '' : 'notFocusable', role: "link", tabIndex: 0, onClick: isFocusable ? this.handleFocus : function () { } }, label),
            isFocusable ? (react_1.default.createElement(styles_1.ChevronWrapper, { onClick: this.handleFocus, role: "link", tabIndex: 0 },
                react_1.default.createElement(styles_1.ChevronArrowRight, null))) : null));
    };
    TreeSelectorItem.propTypes = {
        item: prop_types_1.default.object.isRequired,
        label: prop_types_1.default.string.isRequired,
        focused: prop_types_1.default.bool,
        selected: prop_types_1.default.bool,
        partiallySelected: prop_types_1.default.bool,
        onFocus: prop_types_1.default.func,
        onSelect: prop_types_1.default.func,
        className: prop_types_1.default.string,
    };
    TreeSelectorItem.defaultProps = {
        focused: false,
        selected: false,
        partiallySelected: false,
        className: '',
        onFocus: function () { },
        onSelect: function () { },
    };
    return TreeSelectorItem;
}(react_1.Component));
exports.default = TreeSelectorItem;
//# sourceMappingURL=TreeSelectorItem.js.map